import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, LoadingController, AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';

@IonicPage()
@Component({
  selector: 'page-complaints-and-suggestions',
  templateUrl: 'complaints-and-suggestions.html',
})
export class ComplaintsAndSuggestionsPage {

  myForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, private alertCtrl: AlertController, private loadingCtrl: LoadingController, public navParams: NavParams, private formBuilder: FormBuilder, private fire: AngularFirestore, private Auth: AngularFireAuth) {
    this.myForm = this.formBuilder.group({
      "type": ["complaint", Validators.required],
      "comments": ["", Validators.required]
    });
  }

  ionViewDidLoad() { }

  cancel() {
    this.navCtrl.pop();
  }

  send() {
    this.presentLoading();
    const uid = this.Auth.auth.currentUser.uid;
    this.fire.doc("Users/" + uid).ref.get().then(doc => {
      let data = {
        "type": this.myForm.value.type,
        "comments": this.myForm.value.comments,
        "date": new Date(),
        "checked":false,
        "user": {
          "name": doc.get("name") ? doc.get("name") : '',
          "email": doc.get("email") ? doc.get("email") : '',
          "email2": doc.get("email2") ? doc.get("email2") : '',
          "sex": doc.get("sex") ? doc.get("sex") : '',
          "company": doc.get("company") ? doc.get("company") : '',
          "dob": doc.get("dob") ? doc.get("dob") : '',
          "ocupation": doc.get("ocupation") ? doc.get("ocupation") : '',
          "phone": doc.get("phone") ? doc.get("phone") : '',
          "profile": doc.get("profile") ? doc.get("profile") : {}
        }
      }
      this.fire.collection("complaintsAndSuggestions").add(data).then(() => {
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
          subTitle: 'Gracias por enviarnos tus comentarios, nos pondremos en contacto a la brevedad.',
          buttons: ['Ok']
        });
        alert.present();
        this.navCtrl.pop();
      }).catch(error => {
        console.error(error);
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
          subTitle: 'Se ha producido un error, inténtalo mas tarde.',
          buttons: ['Ok']
        });
        alert.present();
      });
    }).catch(error => {
      console.error(error);
      this.loading.dismiss();
      let alert = this.alertCtrl.create({
        subTitle: 'Se ha producido un error, inténtalo mas tarde.',
        buttons: ['Ok']
      });
      alert.present();
    });
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/complaints-and-suggestions/complaints-and-suggestions.ts